import React from 'react';
import { Box } from '@mui/material';

// Animated engineering grid background overlay.
// Position: absolute, covers parent. Parent must have position:relative.
export default function EngGrid({ opacity = 0.5, animate = true, sx = {} }) {
  return (
    <Box
      aria-hidden="true"
      sx={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        opacity,
        backgroundImage:
          'linear-gradient(rgba(120,150,200,.07) 1px, transparent 1px), linear-gradient(90deg, rgba(120,150,200,.07) 1px, transparent 1px)',
        backgroundSize: '44px 44px',
        ...(animate && {
          animation: 'gridDrift 22s linear infinite',
          '@keyframes gridDrift': { from: { backgroundPosition: '0 0' }, to: { backgroundPosition: '44px 44px' } },
          '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
        }),
        ...sx,
      }}
    />
  );
}
